import Chart from 'react-apexcharts';
import { Dropdown } from '../ui/dropdown/Dropdown';
import { DropdownItem } from '../ui/dropdown/DropdownItem';
import { MoreDotIcon } from '../../icons';
import { useState } from 'react';

export default function MonthlySalesChart() {
  const options = {
    chart: {
      fontFamily: 'Outfit, sans-serif',
      type: 'bar',
      height: 350,
      toolbar: { show: false },
    },
    colors: ['#465fff'],
    plotOptions: {
      bar: {
        columnWidth: '60%',
        borderRadius: 4,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 1, colors: ['transparent'] },
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      fontFamily: 'Outfit, sans-serif',
    },
    yaxis: { labels: { style: { colors: ['#6B7280'] } } },
    grid: {
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    fill: { opacity: 1 },
    tooltip: { y: { formatter: (val) => `${val}` } },
  };

  const series = [
    {
      name: 'Sales',
      data: [385, 201, 298, 187, 195, 291, 110, 215, 390, 280, 112, 200],
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  function toggleDropdown() {
    setIsOpen(!isOpen);
  }

  function closeDropdown() {
    setIsOpen(false);
  }

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-base font-medium text-gray-800 dark:text-white/90">
          Monthly Sales
        </h3>
        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800"
          >
            <MoreDotIcon />
          </button>
          <Dropdown isOpen={isOpen} onClose={closeDropdown}>
            <DropdownItem>View Details</DropdownItem>
            <DropdownItem>Edit</DropdownItem>
          </Dropdown>
        </div>
      </div>
      <Chart options={options} series={series} type="bar" height={280} />
    </div>
  );
}
